webpackJsonp([72476233251319],{

/***/ 105:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 201:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactstrap = __webpack_require__(40);
	
	var _gatsbyLink = __webpack_require__(101);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _siteCollage = __webpack_require__(461);
	
	var _siteCollage2 = _interopRequireDefault(_siteCollage);
	
	var _wintersenseCslMountingCropped = __webpack_require__(462);
	
	var _wintersenseCslMountingCropped2 = _interopRequireDefault(_wintersenseCslMountingCropped);
	
	var _sensorCalibration = __webpack_require__(460);
	
	var _sensorCalibration2 = _interopRequireDefault(_sensorCalibration);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TheSensor = function TheSensor() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactstrap.Container,
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'p',
	          { className: 'lead text-center' },
	          'The Wintersense solution revolves around its sensor. Simply strap it a roadside lighting column for several years\' worth of ',
	          _react2.default.createElement(
	            'span',
	            { className: 'font-weight-bold' },
	            'road surface temperature'
	          ),
	          ' measurements.'
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Deploy it virtually anywhere'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'Installing a traditional road weather outstation at every location of interest isn\'t always practical nor is it rarely affordable. The Wintersense sensor offers far greater freedom.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'This is thanks to the following features:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'Supports the Sigfox communication network and in combination with IoT platforms LTE, NB-IoT and LoRa networks, with coverage growing rapidly across the world.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Requires almost no existing infrastruture. All that\'s needed is something to mount it to (e.g. a lighting column). Please see the ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://docs.wintersense.com/installation/' },
	                  'Installation Guide'
	                ),
	                ' for further details.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The sensor is completely self-contained with no external wiring to hook up. With enough battery capacity to last well over 1 year and possibilities to extend this to several years.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement('img', { src: _siteCollage2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-2' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Fast to install'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'A sensor that\'s faster to install not only saves on labour, but dense networks can be rolled out in a fraction of the time of traditional solutions. It\'s also easy to move sensors around your road network for further insights.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Here\'s a few reasons why it\'s so quick:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'The road temperature sensor uses contactless passive infrared technology, therefore the road surface does not need cutting, saving on traffic disruption.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The majority of LPWAN networks supported have national coverage, so there\'s no need to configure the sensor on site, it\'ll just connect straight out of the box.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Mounting a sensor involves little more than tighting a stainless steel band and checking the sensor\'s alignment.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'The ',
	                _react2.default.createElement(
	                  'a',
	                  { href: 'https://user.wintersense.com' },
	                  'Web Application'
	                ),
	                ' makes it easy to record new installation sites on the go from your smartphone.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md order-md-1' },
	            _react2.default.createElement('img', { src: _wintersenseCslMountingCropped2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'mt-5' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row align-items-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'Focused on accuracy'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: 'text-justify' },
	              'Affordable sensors need not be inaccurate.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Wintersense takes several precautions to ensure accurate measurements:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'The Wintersense team has spent over 3 years testing, trialing, iterating and deploying its road temperature sensor to ensure they are fit for purpose.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Wintersense has invested in a sophisticated climate chamber, capable of subjecting each sensor to freezing conditions to assess if it\'s accurate enough for deployment.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'As with any infrared road temperature sensor, vehicles can cause errors when they block the sensor\'s view of the road surface. Our software filters out any resulting temperature spikes.'
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'Once the sensor uploads it\'s data to the Wintersense cloud servers the data is passed through a variety of quality control checks to flag, and alert of, any suspect data. For more details see ',
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/platform' },
	                  'The Platform'
	                ),
	                '.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-md' },
	            _react2.default.createElement('img', { src: _sensorCalibration2.default, className: 'img-fluid rounded', alt: 'Wintersense sensor' })
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'mt-3' },
	        _react2.default.createElement(
	          'p',
	          { className: 'text-justify' },
	          'For more details please see the ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://www.campbellsci.eu/wintersense' },
	            'specifications'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement('br', null)
	  );
	};
	
	exports.default = TheSensor;
	module.exports = exports['default'];

/***/ }),

/***/ 460:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sensor-calibration.2793b5db.jpg";

/***/ }),

/***/ 461:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/site-collage.dfeabbea.png";

/***/ }),

/***/ 462:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wintersense-csl-mounting-cropped.bdfdc2b3.jpg";

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WinterJumbo = function (_React$Component) {
	  _inherits(WinterJumbo, _React$Component);
	
	  function WinterJumbo() {
	    _classCallCheck(this, WinterJumbo);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  WinterJumbo.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          background: '#00BFF3',
	          padding: '15px',
	          textAlign: 'center'
	        }
	      },
	      _react2.default.createElement(
	        'h1',
	        {
	          style: {
	            marginBottom: '0'
	          }
	        },
	        this.props.title
	      )
	    );
	  };
	
	  return WinterJumbo;
	}(_react2.default.Component);
	
	// Prop types are a feature for runtime validation of props during development.
	
	
	WinterJumbo.propTypes = {
	  title: _propTypes2.default.string.isRequired
	};
	
	exports.default = WinterJumbo;
	module.exports = exports['default'];

/***/ }),

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _TheSensor = __webpack_require__(201);
	
	var _TheSensor2 = _interopRequireDefault(_TheSensor);
	
	var _WinterJumbo = __webpack_require__(73);
	
	var _WinterJumbo2 = _interopRequireDefault(_WinterJumbo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Sensor = function Sensor() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_WinterJumbo2.default, {
	      title: 'The Sensor'
	    }),
	    _react2.default.createElement(_TheSensor2.default, null)
	  );
	};
	
	exports.default = Sensor;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-sensor-js-152b85a54895f759284c.js